import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ link, title }) => <Link to={link} className="action-btn"><span>{title}</span></Link>

export default Button;